import { useSavedEventsContext } from '../contexts';
import type { Event } from '@buzzmap/shared';

/**
 * Hook for managing saved events.
 * Must be used within a SavedEventsProvider.
 */
export function useSavedEvents() {
  const { savedIds, isSaved, toggleSaved, savedCount } = useSavedEventsContext();

  // Convenience method that accepts an Event object
  const saveEvent = (event: Event) => {
    toggleSaved(event.id);
  };

  // Convenience method to check if an event is saved
  const isEventSaved = (event: Event | null) => {
    return event ? isSaved(event.id) : false;
  };

  return {
    savedIds,
    savedCount,
    isSaved,
    isEventSaved,
    toggleSaved,
    saveEvent,
  };
}
